const versions = {
  termsOfService: 1,
  app: process.env.REACT_APP_VERSION
}
export default versions
